import {
    Box,
    Typography,
    Link,
    Grid,
} from '@mui/material';
import {
    Email,
    Language,
    LocalPhone,
    PhoneForwarded,
    WhatsApp,
} from '@mui/icons-material';

const ContactInfo = ({ contact_info, user }) => {
    const contactItems = [
        {
            key: 'phone',
            icon: <LocalPhone fontSize="small" />,
            label: 'Phone',
            value: contact_info.phone,
        },
        {
            key: 'alternate_phone',
            icon: <PhoneForwarded fontSize="small" />,
            label: 'Alternate Phone',
            value: contact_info.alternate_phone,
        },
        {
            key: 'whatsapp',
            icon: <WhatsApp fontSize="small" />,
            label: 'WhatsApp',
            value: contact_info.whatsapp,
        },
        {
            key: 'email',
            icon: <Email fontSize="small" />,
            label: 'Email',
            value: contact_info.email,
            href: contact_info.email ? `mailto:${contact_info.email}` : null,
        },
        {
            key: 'website',
            icon: <Language fontSize="small" />,
            label: 'Website',
            value: contact_info.website,
            href: contact_info.website,
        },
    ].filter(item => item.value); // Only include items with values

    return (
        <>
        {user ? (
            <Grid container spacing={2}>
                {contactItems.map(item => (
                    <Grid size={{ xs: 12, sm: 4 }} key={item.key}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                p: 1,
                            }}
                        >
                            <Box sx={{ mr: 1.5, color: 'primary.main' }}>{item.icon}</Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                                    {item.label}
                                </Typography>
                                {item.href ? (
                                    <Link
                                        href={item.href}
                                        target="_blank"
                                        rel="noopener"
                                        underline="hover"
                                        sx={{ color: 'text.primary', fontWeight: 'medium' }}
                                    >
                                        {item.value}
                                    </Link>
                                ) : (
                                    <Typography variant="body2" fontWeight="medium">
                                        {item.value}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        ) : (
            <Box>
                <Typography variant="body2" color="text.secondary">
                   Sign in to view contact information. <Link href="/signin" underline="hover">Sign In</Link>
                </Typography>
            </Box>
        )}
        </>
    );
};

export default ContactInfo;